import { eTransactionCategory } from 'ui-toolkit/enums/eTransactionType';

export interface IQuoteTransaction {
  transaction_category: eTransactionCategory;
  purchase_price: number | null;
  estimated_property_value: number | null;
  existing_loan_balance: number | null;
  loan_amount: number | null;
}

export const createDefaultQuoteTransaction = (): IQuoteTransaction => ({
  transaction_category: eTransactionCategory.Refinance,
  purchase_price: null,
  estimated_property_value: null,
  existing_loan_balance: null,
  loan_amount: null,
});

export const prettyTransaction: Record<keyof IQuoteTransaction, string> = {
  transaction_category: 'Transaction Category',
  purchase_price: 'Purchase Price',
  existing_loan_balance: 'Existing Loan Balance',
  estimated_property_value: 'Estimated Property Value',
  loan_amount: 'Loan Amount',
};
